// extracted by css-extract-rspack-plugin
export default {"container":"container__pOfn0","content":"content__EbKGo","text":"text__q65Xz","button":"button__vJFaN"};